import { getSSOConfigsCall } from "./constants"

export function getSSOConfigs() {
  return getSSOConfigsCall()
}
